import { render, staticRenderFns } from "./MasiveIncomeDiscount.vue?vue&type=template&id=b78ecee6&"
import script from "./MasiveIncomeDiscount.vue?vue&type=script&lang=js&"
export * from "./MasiveIncomeDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports